import { ArrowDown, ArrowRight } from 'lucide-react'
import { LANDING_PAGE_CHAOS_NODES, LANDING_PAGE_UI } from '@propbix/constants/public'
import { Reveal } from '@/components/Reveal'

export function ProblemStrip() {
  return (
    <section className="section-band-muted" aria-labelledby="problem-heading">
      <div className="page-shell section-y">
        <Reveal className="max-w-3xl">
          <p className="section-label">{LANDING_PAGE_UI.problemLabel}</p>
          <h2 id="problem-heading" className="section-title mt-3">
            {LANDING_PAGE_UI.problemTitle}
          </h2>
          <p className="section-body mt-5">{LANDING_PAGE_UI.problemSubtitle}</p>
        </Reveal>

        <Reveal delay={0.08} className="mt-12">
          <p className="text-xs font-semibold uppercase tracking-[0.14em] text-muted">
            {LANDING_PAGE_UI.problemFromLabel}
          </p>

          <div className="mt-5 flex flex-wrap gap-2.5 md:gap-3">
            {LANDING_PAGE_CHAOS_NODES.map((node, index) => (
              <div
                key={node.id}
                className="chaos-node"
                style={{
                  transform: `rotate(${((index % 5) - 2) * 1.2}deg)`,
                }}
              >
                {node.label}
              </div>
            ))}
          </div>

          <div className="my-8 flex items-center gap-3 text-muted" aria-hidden>
            <div className="h-px flex-1 bg-gradient-to-r from-transparent via-line/25 to-transparent" />
            <ArrowDown size={18} strokeWidth={1.75} className="text-accent" />
            <div className="h-px flex-1 bg-gradient-to-r from-transparent via-line/25 to-transparent" />
          </div>

          <div className="overflow-hidden rounded-[var(--radius-desk)] border border-accent/25 bg-gradient-to-br from-accentSoft/80 to-panel p-5 shadow-[var(--shadow-float)] md:p-7 dark:from-accentSoft/30 dark:to-panel">
            <p className="text-xs font-semibold uppercase tracking-[0.14em] text-accent">
              {LANDING_PAGE_UI.problemConvergeLabel}
            </p>
            <div className="mt-4 flex flex-wrap items-center gap-2">
              <span className="rounded-[var(--radius-control)] bg-brand px-3 py-1.5 text-sm font-semibold text-white dark:bg-accent dark:text-[rgb(var(--cta-ink))]">
                {LANDING_PAGE_UI.brandName}
              </span>
              <ArrowRight size={16} className="text-accent" strokeWidth={2} aria-hidden />
              <span className="text-sm font-medium text-muted">{LANDING_PAGE_UI.problemToLabel}</span>
            </div>
            <p className="mt-4 max-w-[48ch] text-base leading-7 text-ink">
              {LANDING_PAGE_UI.problemConvergeBody}
            </p>
          </div>
        </Reveal>
      </div>
    </section>
  )
}
